/**************************************************
 * Nombre:       Tarjeta_Mixlr
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import imagen from '../../Recursos/tmp_mix.png'
import {GRADIENTE} from "../../Constantes";
import {useCuentaRegresiva} from "../Secciones/Componentes/SubComponentes/Hooks/useCuentaRegresiva";
import {PlayCircleFilledOutlined} from '@mui/icons-material'
import {useEffect, useState} from "react";
import {formatoFechaDaysRedus} from "../../Utilidades/formatoFechaDaysRedus";
import {formatoFechaHora} from "../../Utilidades/formatoFechaHora";
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Mixlr = ({item}) => {
    const [fechaCapa, setFechaCapa] = useState('');
    const {Reloj} = useCuentaRegresiva({fecha: fechaCapa});


    useEffect(() => {

        let fecha = new Date(item.fecha);
        let fechaHora = new Date(item.hora);
        fecha.setHours(fechaHora.getHours(), fechaHora.getMinutes());
        setFechaCapa(fecha);

    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={imagen} alt={'logo'} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 12, color: '#00000080'}}>{item.participante}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography sx={{fontSize: 12, color: '#00000080', textAlign: 'left'}}>
                    {`Fecha: ${formatoFechaDaysRedus(item.fecha)} - Hora: ${formatoFechaHora(item.hora)}`}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                {fechaCapa && fechaCapa.getTime() > new Date().getTime() ?
                    <Reloj/>
                    :
                    <Button
                        onClick={() => irUrl(item.link)}
                        endIcon={<PlayCircleFilledOutlined/>} sx={{background: GRADIENTE}}>
                        Escuchar
                    </Button>
                }

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Mixlr    